import { Autocomplete, TextField } from '@mui/material';
import { ChangeEvent, FC, useEffect, useState } from 'react';

interface EmailAutosuggestProperties {
    allowedDomains: string[] | undefined;
    disabled: boolean;
    email: string;
    error: boolean;
    handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    helperText: string;
}

const createChangeEvent = (name: string, value: string): ChangeEvent<HTMLInputElement> => {
    return {
        target: { name, value } as HTMLInputElement
    } as ChangeEvent<HTMLInputElement>;
};

const EmailAutosuggest: FC<EmailAutosuggestProperties> = ({ allowedDomains, disabled, email, error, handleInputChange, helperText }) => {
    const [inputValue, setInputValue] = useState<string>(email);

    useEffect(() => {
        handleInputChange(createChangeEvent('email', inputValue));
    }, [inputValue, handleInputChange]);

    const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setInputValue(value);
    };

    return (
        <Autocomplete
            freeSolo
            options={allowedDomains ? allowedDomains.map((currentDomain) => `${inputValue.split('@')[0]}@${currentDomain}`) : ['@plick.eu']}
            inputValue={inputValue || ''}
            disabled={disabled}
            onInputChange={(event, newInputValue) => {
                if (event && event.type === 'change') {
                    handleInput(event as ChangeEvent<HTMLInputElement>);
                } else {
                    setInputValue(newInputValue);
                }
            }}
            renderInput={(params) => <TextField {...params} error={error} helperText={helperText} label="Email" name="email" value={inputValue} onChange={handleInput} required />}
        />
    );
};

export default EmailAutosuggest;
